import React from 'react';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import { mail } from '../utilities/fetch';

export default function ContactModal(props) {

    const handleSubmit = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;

        mail.post('send', {
            'to': 'pandamixve@gmail.com',
            'subject': form.formGroupSubject.value,
            'message': form.formGroupMessage.value,
            'headers': `From: ${form.formGroupName.value} <${form.formGroupEmail.value}>`
        });

        props.onHide();
    }

    return (
        <Modal show={props.show} onHide={props.onHide} centered className="contact-modal">
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col xs="12" md="6">
                            <Form.Group controlId="formGroupName" className="contact-form-group">
                                <Form.Label className="contact-label">Nombre</Form.Label>
                                <Form.Control as="input" type="text" placeholder="Nombre y Apellido" className="contact-form" required />
                            </Form.Group>
                        </Col>
                        <Col xs="12" md="6">
                            <Form.Group controlId="formGroupEmail" className="contact-form-group">
                                <Form.Label className="contact-label">Correo</Form.Label>
                                <Form.Control as="input" type="email" placeholder="Correo Electronico" className="contact-form" required />
                            </Form.Group>
                        </Col>
                        <Col xs="12">
                            <Form.Group controlId="formGroupSubject" className="contact-form-group">
                                <Form.Label className="contact-label">Asunto</Form.Label>
                                <Form.Control as="input" type="text" placeholder="Asunto del Mensaje" className="contact-form" required />
                            </Form.Group>
                        </Col>
                        <Col xs="12">
                            <Form.Group controlId="formGroupMessage" className="contact-form-group">
                                <Form.Label className="contact-label">Mensaje</Form.Label>
                                <Form.Control as="textarea" placeholder="Cuentanos tus dudas" className="contact-form" required />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button type="submit" className="contact-button send">Enviar</Button>
                            <Button className="contact-button" onClick={props.onHide}>Cancelar</Button>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
        </Modal>
    )
}
